import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MockStatsService } from "../../services/MockStatsService";

const FooterComponentOpenData = () => {
    const [stats, setStats] = useState({
        today: 0,
        thisWeek: 0,
        thisMonth: 0,
        totalHits: 0
    });

    useEffect(() => {
        const loadStats = async () => {
            const data = await MockStatsService.getVisitorStats();
            setStats(data);
        };
        loadStats();
    }, []);

    return (
        <div>
            <footer id="footer" data-aos="fade-in">
                <div className="footer-top">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-md-6 footer-link text-center mb-4 mb-lg-0">
                                <center>
                                    <div className="logo-footer">
                                        <img src={`${process.env.PUBLIC_URL}/sampang.png`} alt="Sampang" />
                                    </div>
                                </center>
                                <p>
                                    Jl. Jamaluddin No.1A, <br /> Kec. Sampang, Kab. Sampang, <br />
                                    Jawa Timur 69213
                                </p>
                            </div>

                            <div className="col-lg-2 col-md-6 footer-links mb-4 mb-lg-0">
                                <h4>Menu</h4>
                                <ul>
                                    <li><i className="bx bx-chevron-right"></i> <Link to="/open_data">Beranda</Link></li>
                                    <li><i className="bx bx-chevron-right"></i> <Link to="/open_data/kumpulan_data">Kumpulan Data</Link></li>
                                    <li><i className="bx bx-chevron-right"></i> <Link to="/open_data/organisasi">Organisasi</Link></li>
                                    <li><i className="bx bx-chevron-right"></i> <Link to="/open_data/kategori">Kategori</Link></li>
                                    <li><i className="bx bx-chevron-right"></i> <Link to="/open_data/infografik">Infografik</Link></li>
                                    <li><i className="bx bx-chevron-right"></i> <Link to="/open_data/tentang">Tentang</Link></li>
                                </ul>
                            </div>

                            <div className="col-lg-3 col-md-6 footer-link mb-4 mb-lg-0">
                                <h4>Kontak</h4>
                                <p className="flex-content">
                                    <span><i className="bx bx-phone font-size-20 mr-1"></i></span>
                                    <span> (0323) 325987 / 321550</span>
                                </p>
                                <p className="flex-content">
                                    <span><i className="bx bx-envelope font-size-20 mr-1"></i></span>
                                    <span> statistik@sampangkab.go.id</span>
                                </p>

                                {/* <h4 className="mt-4">Ikuti Kami</h4>
                                <div className="social-links mt-3">
                                    <a href="#" className="twitter"><i className="bx bxl-twitter"></i></a>
                                    <a href="#" className="facebook"><i className="bx bxl-facebook"></i></a>
                                    <a href="#" className="instagram"><i className="bx bxl-instagram"></i></a>
                                    <a href="#" className="youtube"><i className="bx bxl-youtube"></i></a>
                                </div> */}
                            </div>

                            <div className="col-lg-4 col-md-6 footer-links mb-4 mb-lg-0">
                                <h4>Statistik Pengunjung</h4>
                                <ul style={{ listStyle: "none", padding: 0 }}>
                                    <li className="d-flex justify-content-between mb-2 pb-1 border-bottom">
                                        <span className="text-muted">Hari ini</span>
                                        <span className="font-weight-600 font-size-16">{(stats.today || 0).toLocaleString('id-ID')}</span>
                                    </li>
                                    <li className="d-flex justify-content-between mb-2 pb-1 border-bottom">
                                        <span className="text-muted">Minggu ini</span>
                                        <span className="font-weight-600 font-size-16">{(stats.thisWeek || 0).toLocaleString('id-ID')}</span>
                                    </li>
                                    <li className="d-flex justify-content-between mb-2 pb-1 border-bottom">
                                        <span className="text-muted">Bulan ini</span>
                                        <span className="font-weight-600 text-success font-size-16">{(stats.thisMonth || 0).toLocaleString('id-ID')}</span>
                                    </li>
                                    <li className="d-flex justify-content-between mt-3">
                                        <span className="fw-bold">Total Pengunjung</span>
                                        <span className="fw-bold text-success font-size-18">{(stats.totalHits || 0).toLocaleString('id-ID')}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container py-4">
                    <div className="copyright">
                        &copy; Copyright <strong><span>2024</span></strong>. All Rights Reserved
                    </div>
                </div>
            </footer>
            <a href="#" className="back-to-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a>
        </div>
    );
};

export default FooterComponentOpenData;